const getElectronAppVersion = () => {
  return window.electron?.application.getVersion();
};

export default getElectronAppVersion;
